import { Box, Button, Heading } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ScheduleManagementPage } from './ScheduleManagementPage';

/** Routed wrapper around the location-level content-scheduling editor. */
export function LocationSchedulePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { locationId } = useParams<{ locationId: string }>();

  if (!locationId) return null;

  return (
    <Box maxW="900px">
      <Button
        variant="link"
        color="gray.500"
        leftIcon={<ArrowBackIcon />}
        mb={4}
        onClick={() => navigate('/organization/locations')}
      >
        {t('locations.backToLocations')}
      </Button>
      <Heading size="lg" color="gray.800" mb={5}>
        {t('locations.scheduling')}
      </Heading>
      <ScheduleManagementPage locationId={locationId} />
    </Box>
  );
}

export default LocationSchedulePage;
